import { authEntityReducer } from '@root/store/slices/entities/auth';
import { combineReducers } from 'redux';
import { appEntityReducer } from './app';
import { userDashboardReducer } from './dashboard';

const entitiesReducer = combineReducers({
  app: appEntityReducer,
  auth: authEntityReducer,
  dashboard: userDashboardReducer,
});

export { entitiesReducer };

  export * from './app';
  export * from './auth';
  export * from './dashboard';

